import React, { useEffect } from "react";
import HeaderBar from "./common/HeaderBar";
import FooterBar from "./common/FooterBar";
import "../style/about.scss";
import privacy from "../image/privacy.webp";

const Privacy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <React.Fragment>
      <HeaderBar />
      <div className="mx-auto max-w-container py-20 text-[14px] leading-8">
        <p className="mb-10 text-[20px]">Privacy Policy</p>
        <p className="leading-10">
          Last updated: May 8, 2026
          <br />
          This Privacy Policy describes how Elvorloy, The Leather Store (the
          "Site", "we", "us", or "our") collects, uses, and discloses your
          personal information when you visit, use our services, or make a
          purchase from Elvorloy.com (the "Site") or otherwise communicate with
          us regarding the Site (collectively, the "Services"). For purposes of
          this Privacy Policy, "you" and "your" means you as the user of the
          Services, whether you are a customer, website visitor, or another
          individual whose information we have collected pursuant to this
          Privacy Policy.
          <br />
          Please read this Privacy Policy carefully. By using and accessing any
          of the Services, you agree to the collection, use, and disclosure of
          your information as described in this Privacy Policy. If you do not
          agree to this Privacy Policy, please do not use or access any of the
          Services.
          <br />
          Changes to This Privacy Policy
          <br />
          We may update this Privacy Policy from time to time, including to
          reflect changes to our practices or for other operational, legal, or
          regulatory reasons. We will post the revised Privacy Policy on the
          Site, update the "Last updated" date and take any other steps required
          by applicable law.
          <br />
          How We Collect and Use Your Personal Information
          <br />
          To provide the Services, we collect and have collected over the past
          12 months personal information about you from a variety of sources, as
          set out below. The information that we collect and use varies
          depending on how you interact with us.
          <br />
          In addition to the specific uses set out below, we may use information
          we collect about you to communicate with you, provide or improve or
          improve the Services, comply with any applicable legal obligations,
          enforce any applicable terms of service, and to protect or defend the
          Services, our rights, and the rights of our users or others.
          <br />
          What Personal Information We Collect
          <br />
          The types of personal information we obtain about you depends on how
          you interact with our Site and use our Services. When we use the term
          "personal information", we are referring to information that
          identifies, relates to, describes or can be associated with you. The
          following sections describe the categories and specific types of
          personal information we collect.
          <br />
          Information We Collect Directly from You
          <br />
          Information that you directly submit to us through our Services may
          include:
          <br />
          Contact details including your name, address, phone number, and email.
          <br />
          Order information including your name, billing address, shipping
          address, payment confirmation, email address, and phone number.
          <br />
          Account information including your username, password, security
          questions and other information used for account security purposes.
          <br />
          Shopping information including the items you view, put in your cart,
          saved into your account like loyalty points, reviews, referrals or
          gift cards, or purchases.
          <br />
          Loyalty points/product reviews/referrals/gift cards saved
          <br />
          Customer support information including the information you choose to
          include in communications with us, for example, when sending a message
          through the Services.
          <br />
          Some features of the Services may require you to directly provide us
          with certain information about yourself. You may elect not to provide
          this information, but doing so may prevent you from using or accessing
          these features.
          <br />
          Information We Collect about Your Usage
          <br />
          We may also automatically collect certain information about your
          interaction with the Services ("Usage Data"). To do this, we may use
          cookies, pixels and similar technologies ("Cookies"). Usage Data may
          include information about how you access and use our Site and your
          account, including device information, browser information,
          information about your network connection, your IP address and other
          information regarding your interaction with the Services.
          <br />
          Information We Obtain from Third Parties
          <br />
          Finally, we may obtain information about you from third parties,
          including from vendors and service providers who may collect
          information on our behalf, such as:
          <br />
          Companies who support our Site and Services, such as Shopify.
          <br />
          Our payment processors, who collect payment information (e.g., bank
          account, credit or debit card information, billing address) to process
          your payment in order to fulfill your orders and provide you with
          products or services you have requested, in order to perform our
          contract with you. When you visit our Site, open or click on emails we
          send you, or interact with our Services or advertisements, we, or
          third parties we work with, may automatically collect certain
          information using online tracking technologies such as pixels, web
          beacons, software developer kits, third-party libraries, and cookies.
          Any information we obtain from third parties will be treated in
          accordance with this Privacy Policy. Also see the section below, Third
          Party Websites and Links.
          <br />
          How We Use Your Personal Information
          <br />
          Providing Products and Services. We use your personal information to
          provide you with the Services in order to perform our contract with
          you, including to process your payments, fulfill your orders, to send
          notifications to you related to your account, purchases, returns,
          exchanges or other transactions, to create, maintain and otherwise
          manage your account, to arrange for shipping, facilitate any returns
          and exchanges and other features and functionalities related to your
          account. We may also enhance your shopping experience by enabling
          Shopify to match your account with other Shopify services that you may
          choose to use. In this case, Shopify will process your information as
          set forth in its Privacy Policy and Consumer Privacy Policy. Marketing
          and Advertising. We may use your personal information for marketing
          and promotional purposes, such as to send marketing, advertising and
          promotional communications by email, text message or postal mail, and
          to show you advertisements for products or services. This may include
          using your personal information to better tailor the Services and
          advertising on our Site and other websites. Security and Fraud
          Prevention. We use your personal information to detect, investigate or
          take action regarding possible fraudulent, illegal or malicious
          activity. If you choose to use the Services and register an account,
          you are responsible for keeping your account credentials safe. We
          highly recommend that you do not share your username, password, or
          other access details with anyone else. If you believe your account has
          been compromised, please contact us immediately.. Communicating with
          You and Service Improvement. We use your personal information to
          provide you with customer support and improve our Services. This is in
          our legitimate interests in order to be responsive to you, to provide
          effective services to you, and to maintain our business relationship
          with you
        </p>
      </div>
      <FooterBar />
    </React.Fragment>
  );
};

export default Privacy;
